import { useContext } from 'react'

import CreateApiClientContext from '@dc-shared-web/providers/CreateApiClientContext'

const { Provider, context } = CreateApiClientContext({
  disableXRequestedWith: true,
})

export const SvcLiveblocksProvider = Provider

export const useSvcLiveblocksContext = () => useContext(context)
